"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _mixinPanel = _interopRequireDefault(require("@/libs/flowable/common/mixinPanel"));
var _mixinExecutionListener = _interopRequireDefault(require("@/libs/flowable/common/mixinExecutionListener"));
var _signal = _interopRequireDefault(require("./property/signal"));
var _parseElement = require("@/libs/flowable/common/parseElement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    signalDialog: _signal.default
  },
  mixins: [_mixinPanel.default, _mixinExecutionListener.default],
  data: function data() {
    return {
      signalLength: 0,
      formData: {}
    };
  },
  computed: {
    formConfig: function formConfig() {
      var _this = this;
      return {
        inline: false,
        item: [{
          xType: 'input',
          name: 'processCategory',
          label: '流程分类'
        }, {
          xType: 'input',
          name: 'id',
          label: '流程标识key',
          rules: [{
            required: true,
            message: 'Id 不能为空'
          }]
        }, {
          xType: 'input',
          name: 'name',
          label: '流程名称',
          rules: [{
            required: true,
            message: 'Id 不能为空'
          }]
        }, {
          xType: 'input',
          name: 'documentation',
          label: '节点描述'
        }, {
          xType: 'slot',
          name: 'executionListener',
          label: '执行监听器'
        }, {
          xType: 'slot',
          name: 'signal',
          label: '信号定义'
        }]
      };
    }
  },
  watch: {
    'formData.processCategory': function formDataProcessCategory(val) {
      if (val === '') val = null;
      this.updateProperties({
        'flowable:processCategory': val
      });
    }
  },
  created: function created() {
    this.formData = (0, _parseElement.commonParse)(this.element);
  },
  methods: {
    computedSignalLength: function computedSignalLength() {
      var len = this.element.businessObject.extensionElements.values.length;
      this.signalLength = len === null || len === undefined ? 0 : len;
    },
    finishSignal: function finishSignal() {
      if (this.dialogName === 'signalDialog') {
        this.computedSignalLength();
      }
      this.dialogName = '';
    }
  }
};